import React, { useState } from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import {
  DialogActions,
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { Box } from "@mui/system";
import { DigitalClock } from "../components/DigitalClock";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { getDefaultDateTime, validateEmail } from "../Utils/utils";

const getDefaultDate = (date) => {
  const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  return newDate;
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(0),
    display: "flex",
    justifyContent: "space-between",
    marginTop: "15px",
  },
  "&:-webkit-autofill": {
    WebkitBoxShadow: "0 0 0 1000px white inset",
    fontSize: "30px",
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  "&:-webkit-autofill": {
    WebkitBoxShadow: "0 0 0 1000px white inset",
    fontSize: "30px",
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle
      sx={{ m: 0, p: 2 }}
      {...other}
      style={{ display: "flex", justifyContent: "center" }}
    >
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
};

const getHour = (date) => {
  let currentHour = date.getHours();
  let currentMinutes = date.getMinutes();
  let currentPeriod = currentHour >= 12 ? "pm" : "am";
  currentHour = currentHour % 12;
  currentHour = currentHour ? currentHour : 12;

  return `${currentHour.toString().padStart(2, "0")}:${currentMinutes
    .toString()
    .padStart(2, "0")} ${currentPeriod}`;
};

export const PickupOrder = (props) => {
  const {
    pickUpTime,
    companyName,
    onTextChange,
    onEMailChange,
    onPhoneChange,
    onDateChange,
    onTimeChange,
    onAlert,
    customerData,
    onShowClock,
    showClock,
  } = props;

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "15px",
          flexDirection: "column",
        }}
      >
        <StyledTextField
          id="phoneNo"
          type="tel"
          required
          label="Phone No."
          variant="outlined"
          onChange={(e) => onPhoneChange(e)}
          value={customerData.phoneNo}
          fullWidth
        />
        <TextField
          id="email"
          type="text"
          label="E-Mail:"
          variant="outlined"
          value={customerData.email}
          onChange={onEMailChange}
          fullWidth
        />
        <TextField
          id="firstName"
          required
          label="First Name:"
          variant="outlined"
          value={customerData.firstName}
          onChange={onTextChange}
          fullWidth
        />
        <TextField
          id="lastName"
          label="Last Name:"
          variant="outlined"
          value={customerData.lastName}
          onChange={onTextChange}
          fullWidth
        />
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <MobileDatePicker
            id="date"
            label="Date:"
            inputFormat="MM/dd/yyyy"
            value={customerData.date}
            onChange={(e) => onDateChange(e)}
            renderInput={(params) => (
              <TextField required {...params} fullWidth />
            )}
            minDate={getDefaultDateTime(pickUpTime)}
            maxDate={getDefaultDateTime(pickUpTime)}
          />
        </LocalizationProvider>

        <FormControl variant="outlined" required fullWidth focused>
          <InputLabel htmlFor="time">Time:</InputLabel>
          <OutlinedInput
            id="time"
            type="text"
            value={getHour(customerData.time)}
            onClick={() => {
              onShowClock(true);
            }}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle digital clock"
                  edge="end"
                  onClick={() => onShowClock(true)}
                >
                  <AccessTimeIcon />
                </IconButton>
              </InputAdornment>
            }
            label="Time:"
          />
        </FormControl>
        <Typography variant="body2">
          {`By proceeding, you consent to get calls, SMS messages, or emails
                including by automated means, from ${companyName} and its affiliates to
                the number and email provided.`}
        </Typography>
        {showClock ? (
          <DigitalClock
            date={customerData.time}
            open={showClock}
            onAlert={onAlert}
            onClose={() => onShowClock(false)}
            onSave={onTimeChange}
          />
        ) : null}
      </Box>
    </Box>
  );
};

// const handleDateChange = (newValue) => {
//   const data = { ...pickUpInfo };

//   data.date = newValue;

//   setPickUpInfo(data);
// };

// const handleTimeChange = (newValue) => {
//   const data = { ...pickUpInfo };

//   data.time = newValue;
//   setPickUpInfo(data);
//   setShowClock(false);
// };

// const handleTextChange = (e) => {
//   const id = e.target.id;
//   const value = e.target.value;
//   let letters = /^[a-zA-Z ]*$/;
//   if (value.match(letters)) {
//     let data = { ...pickUpInfo };
//     data[id] = value;
//     setPickUpInfo(data);
//   }
// };

// const handleEmailChange = (e) => {
//   const id = e.target.id;
//   const value = e.target.value;
//   let data = { ...pickUpInfo };
//   data[id] = value;
//   setPickUpInfo(data);
// };

// const handlePhoneChange = (e) => {
//   const re = /^[0-9\b]+$/;
//   const value = e.target.value;
//   let data = { ...pickUpInfo };
//   if (value === "" || (re.test(value) && value.length <= 10)) {
//     data.phoneNo = value;
//     setPickUpInfo(data);
//   }
// };
